import {ActionType as TSActionType, getType} from 'typesafe-actions';

import * as InteractStateActions from './actions';
import {Highlight, HighlightUpdate, InteractState} from './types';

export const EMPTY_STATE: InteractState = {
  highlight: {},
  panelSelection: [],
};

function updateHighlight(
  highlight: Highlight,
  {axis, value, metric}: HighlightUpdate
): Highlight {
  const newHighlight = {...highlight};

  if (value == null) {
    delete newHighlight[axis];
    // Clear metric when clearing run:name
    if (axis === 'run:name') {
      delete newHighlight['run:metric'];
    }
  } else {
    newHighlight[axis] = value;
    // Store/clear metric alongside run:name
    if (axis === 'run:name') {
      if (metric != null) {
        newHighlight['run:metric'] = metric;
      } else {
        delete newHighlight['run:metric'];
      }
    }
  }

  return newHighlight;
}

export default function reducer(
  state: InteractState = EMPTY_STATE,
  action: TSActionType<typeof InteractStateActions>
) {
  switch (action.type) {
    case getType(InteractStateActions.setHighlight): {
      return {
        ...state,
        highlight: updateHighlight(state.highlight, action.payload),
      };
    }
    case getType(InteractStateActions.setHighlights): {
      const {highlights} = action.payload;
      return {
        ...state,
        highlight: highlights.reduce(updateHighlight, state.highlight),
      };
    }
    case getType(InteractStateActions.setPanelSelection): {
      return {
        ...state,
        panelSelection: action.payload.value,
      };
    }
    default: {
      return state;
    }
  }
}
